import { t } from "../i18n";
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthProvider';
import AuthShell from '../components/AuthShell';
import Login from '../views/pages/authentication/authentication3/Login3';
import ForgetPassword from '../views/pages/authentication/authentication3/forgetPassword';
import AuthenticationLayout from '../layout/AuthenticationLayout';
import { ResetPasswordPage, NewPasswordPage } from './AuthenticationPages';
import Home from '../pages/Home';
import Administratives from '../pages/Administratives';
import Professionals from '../pages/Professionals';
import Organization from '../pages/Organization';
import Patients from '../pages/Patients';
import Agenda from '../pages/Agenda';
import Profile from '../pages/Profile';
import Settings from '../pages/Settings';
import SelectAccess from '../pages/SelectAccess';
import MainLayout from '../layout/MainLayout';
import { portalConfig } from '../configs/portal';
function AccessStatus() {
  const {
    status,

    logout,
    loadAccess
  } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const handleLogout = async () => {
    setBusy(true);
    setError(false);
    try {
      await logout();
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };
  return <AuthShell title={status === 'denied' ? t('Acesso indisponível') : t('Não foi possível validar o acesso')}>
            <Stack spacing={2}>
                <Alert severity={status === 'denied' ? 'warning' : 'error'}>
                    {status === 'denied' ? t('Esta conta não tem um perfil de gestão de clínica válido para este portal.') : t('Não foi possível consultar a sua conta. Verifique a ligação e tente novamente.')}
                </Alert>
                <Typography color="text.secondary">{t("Pode terminar a sessão para utilizar outra conta.")}</Typography>
                {t(error) && <Alert severity="error">{t("Não foi possível terminar a sessão. Tente novamente.")}</Alert>}
                {status === 'error' && <Button type="button" variant="contained" disabled={busy} onClick={loadAccess}>{t("Tentar novamente")}</Button>}
                <Button type="button" variant="outlined" disabled={busy} onClick={handleLogout}>
                    {busy ? 'Aguarde…' : t('Terminar sessão')}
                </Button>
            </Stack>
        </AuthShell>;
}
export default function AppRoutes() {
  const {
    status, role
  } = useAuth();
  if (status === 'loading' || status === 'switching') return <Stack alignItems="center" spacing={2} sx={{
    py: 10
  }} role="status">
            <CircularProgress />
            <Typography>{t("A validar a sessão…")}</Typography>
        </Stack>;
  if (status === 'denied' || status === 'error') return <AccessStatus />;
  if (status === 'select-access') return (
      <Routes>
          <Route element={<AuthenticationLayout />}>
              <Route path="*" element={<SelectAccess />} />
          </Route>
      </Routes>
  );
  return <Routes>
            <Route element={status === 'ready' ? <Navigate to="/" replace /> : <AuthenticationLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgetPassword" element={<ForgetPassword />} />
                <Route path="/forgetPassword/changePassword" element={<ResetPasswordPage />} />
                <Route path="/changePassword" element={<NewPasswordPage />} />
                <Route path="/recover-password" element={<Navigate to="/forgetPassword" replace />} />
            </Route>
            <Route element={status === 'ready' ? <MainLayout /> : <Navigate to="/login" replace />}>
                {portalConfig.routes.map(route => <Route key={route.id} path={route.path} element={route.allowedRoles && !route.allowedRoles.includes(role?.name) ? <Navigate to="/" replace /> : route.id === 'administratives' ? <Administratives key={role?.uuid} /> : route.id === 'professionals' ? <Professionals key={role?.uuid} /> : route.id === 'organization' ? <Organization key={role?.uuid} /> : route.id === 'patients' ? <Patients key={role?.uuid} /> : route.id === 'agenda' ? <Agenda key={role?.uuid} /> : route.id === 'profile' ? <Profile /> : route.id === 'settings' ? <Settings /> : <Home />} />)}
            </Route>
            <Route path="*" element={<Navigate to={status === 'ready' ? '/' : '/login'} replace />} />
        </Routes>;
}
